<template>
  <div class="compute" v-if="locale.newkeypair">
    <div class="content-headline">
      <div class="content-headline__wrapper">
        <h1>{{locale.newkeypair.newkeypair}}</h1>
      </div>
    </div>
    <errorMessages v-for="error in errors.all()" v-bind:key="error.id" v-bind:error="error"/>

    <form class="form" @submit.prevent="submit">
      <div class="fields"> <!-- Message input !-->
        <label for="name">{{locale.newkeypair.name}}</label>
        <input v-validate="'required|alpha_num|min:5'" :data-vv-as="locale.newkeypair.name" type="text" id="name" name="name" v-model="form.name" :placeholder="locale.newkeypair.namePlace">
        <label for="pubkey">{{locale.newkeypair.pubkey}}</label>
        <textarea v-validate="{ required: true, regex: /^ssh-rsa [0-9A-Za-z+\/].*/ }" :data-vv-as="locale.newkeypair.pubkey" id="pubkey" name="message" v-model="form.keypair" rows="5"></textarea>
      </div>
      <!-- Submit button !-->
      <button name="submit" type="submit" class="button">{{ locale.newkeypair.buttonText }}</button>
    </form>
  </div>
</template>

<script>
import errorMessages from '../utils/errorMessages.vue'
import { mapState } from 'vuex'

export default {
  name: 'NewKeypair',
  components: { errorMessages },
  computed: {
    ...mapState(['locale'])
  },
  data: function () {
    return {
      form: {
        name: '',
        keypair: ''
      },
      buttonText: 'Create'
    }
  },
  methods: {
    submit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('keypairs/createNewKeypair', this.form).then((response) => {
            console.log('success')
            this.buttonText = 'Success'
            console.log(response)
            this.$router.push({name: 'Keypair'})
          }).catch((error) => {
            console.log(error)
            this.buttonText = 'Error'
          })
        }
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/NewKeypair.vue